var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { signalPdfError } from './signalPdfError';
/**
 * Retrieves headers for printing to PDF mode. Waits until the headers are available
 * within the `window.pdf` object, with a maximum timeout of 120 seconds.
 * @returns {Promise<{ [key: string]: string } | undefined>} A promise that resolves to the headers
 * (if found) or `undefined` if the operation times out.
 */
export function getPrintToPdfModeHeaders() {
    return __awaiter(this, void 0, void 0, function* () {
        let i = 0;
        let headers = undefined;
        const renderTimeoutInSeconds = 120;
        while (!headers && i++ < renderTimeoutInSeconds) {
            yield new Promise((resolve) => {
                setTimeout(() => {
                    if ('pdf' in window &&
                        isObjectWithOwnKeys(window.pdf) &&
                        'headers' in window.pdf &&
                        isObjectWithOwnKeys(window.pdf.headers)) {
                        headers = window.pdf.headers;
                    }
                    return resolve(undefined);
                }, 1000);
            });
        }
        if (!headers) {
            signalPdfError('failed to find window.pdf');
        }
        else {
            return headers;
        }
    });
}
/**
 * Checks if the provided value is an object with its own enumerable keys.
 * @param {unknown} value - The value to check.
 * @returns {boolean} `true` if the value is an object with own keys, otherwise `false`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isObjectWithOwnKeys(value) {
    return typeof value === 'object' && value !== null && Object.keys(value).length > 0;
}
